module.exports = __webpack_public_path__ + "img/icon-user.86479fc3.svg";